import React from 'react';
import classNames from 'classnames';
import { CloseButton } from '../../buttons';
import { FileUploaderFlow } from './file-uploader';
import { formatMessage } from '@/utils/i18n';
import AIStatementReaderBanner from './ai-statement-reader-banner/AIStatementReaderBanner';
import Modal from '@/views/components/modals/AccessibleModal';

export type Props = {
  className?: string;
  onCancel: () => void;
  show: boolean;
  titleId: string;
  backdropClassName?: string;
};

export default function PortfolioUploadModal({ backdropClassName, show, onCancel, className, titleId }: Props) {
  return (
    <Modal
      show={show}
      size="lg"
      onHide={onCancel}
      className={classNames('portfolio-upload-modal', className)}
      dialogClassName="modal-dialog-centered"
      backdropClassName={backdropClassName}
    >
      <Modal.Header>
        <Modal.Title>{formatMessage(titleId)}</Modal.Title>
        {!!onCancel && <CloseButton onClick={onCancel} />}
      </Modal.Header>
      <Modal.Body>
        <AIStatementReaderBanner />
        <FileUploaderFlow onClose={onCancel} />
      </Modal.Body>
    </Modal>
  );
}
